import React, { useState } from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
    FormControl,
    FormLabel,
    Input,
    useColorModeValue,
    Icon,
    Flex,
} from '@chakra-ui/react';
import { FaPaperPlane } from 'react-icons/fa';
import { Spinner } from '@chakra-ui/react';

const InviteFounderModal = ({ isOpen, onClose, onSend, isLoading, invitedEmail, setInvitedEmail }) => {
    const bg = useColorModeValue('white', 'gray.800');
    const borderColor = useColorModeValue('gray.200', 'gray.600');

    const handleSend = () => {
        if (invitedEmail.trim()) {
            onSend?.(invitedEmail);
        }
    };

    const handleClose = () => {
        setInvitedEmail('');
        onClose();
    };

    if (!isOpen) return null;

    return (
        <Modal isOpen={isOpen} onClose={handleClose} isCentered closeOnOverlayClick={false}>
            <ModalOverlay />
            <ModalContent
                w={{ base: '90%', sm: '500px', md: '550px' }}
                maxW="90vw"
                borderRadius="lg"
                p={6}
                bg={bg}
                boxShadow="lg"
            >
                <ModalCloseButton />
                <ModalHeader
                    fontSize="xl"
                    fontWeight="bold"
                    pb={4}
                    px={0}
                >
                    Invite Founder
                </ModalHeader>

                <ModalBody px={0} pb={4}>
                    <FormControl>
                        <FormLabel fontSize="md" mb={2} color="gray.700">
                            Email Address
                        </FormLabel>
                        <Input
                            type="email"
                            placeholder="founder@example.com"
                            value={invitedEmail}
                            onChange={(e) => setInvitedEmail(e.target.value)}
                            focusBorderColor="brand.primary"
                            borderColor={borderColor}
                            borderRadius="md"
                            _focus={{
                                borderColor: 'brand.primary',
                                boxShadow: '0 0 0 1px var(--chakra-colors-brand-primary)',
                            }}
                        />
                    </FormControl>
                </ModalBody>

                <ModalFooter justifyContent="flex-end" gap={3} px={0} pt={2}>
                    <Button
                        variant="outline"
                        onClick={handleClose}
                        borderRadius="md"
                        borderColor={borderColor}
                        color="gray.700"
                        _hover={{
                            bg: 'gray.50',
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        bg="brand.primary"
                        color="white"
                        onClick={handleSend}
                        isLoading={isLoading}
                        borderRadius="md"
                        _hover={{
                            bg: 'brand.dark',
                        }}
                        _active={{
                            bg: 'brand.secondary',
                        }}
                        leftIcon={<Icon as={FaPaperPlane} />}
                    >
                        {isLoading ? <Spinner /> : 'Send'}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default InviteFounderModal;